import React from "react";
import "./styles/hero.css";
export default function AirDropHero() {
  return (
    <div className="airdrop-container container-fluid d-flex justify-content-center align-items-center">
      <div className="row py-5 d-flex justify-content-center align-items-center ">
        <div className="col-12 d-flex justify-content-center align-items-center flex-column">
          <h1 className="airdrop-title  text-start">Task Center</h1>
          <p className="airdrop-para text-start">Invite Friends and Receive</p>
          <p className="airdrop-para text-start">More ETWhite PaperBP</p>
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center ">
          <button className="airdrop-white me-5">White paper Now</button>
          <button className="airdrop-bp">BP</button>
        </div>
      </div>
    </div>
  );
}
